/** The product name, in one place: every wordmark and the page title use it. */
export const APP_NAME = "hali-shares";
